
export const PatientSpecialAccommodationIcon = ({ fill = "var(--ant-primary-color)", width = 20, height = 20 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            fill='var(--ant-primary-color)'
            width={width}
            height={height}
            viewBox="0 0 16 16" >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <g>
                    <path class="secondary" fill="#FFA500" d="M15.88,14.78,11.08,6.7a.66.66,0,0,0-1.14,0L5.11,14.83c-.26.44-.05,1.17.46,1.17h9.88C16,16,16.14,15.22,15.88,14.78Zm-4.8.25H9.91V13.86h1.17Zm0-2.44H9.92l-.1-4.15h1.35Z"></path>
                    <path d="M4.5,9.12A4.52,4.52,0,0,0,0,13.62,2.34,2.34,0,0,0,0,14H4.44l2.9-4.88ZM7,7.88a4,4,0,0,0,1.2-.21l.88-1.48a1.64,1.64,0,0,1,1.43-.81h.14A3.93,3.93,0,1,0,3.06,3.94,4,4,0,0,0,7,7.88Z"></path>
                </g>
            </g>
        </svg>
    );
};